

import React, { useState } from 'react'
import { LockOpenIcon } from '@heroicons/react/outline'
import AuthService from '../../../services/AuthService';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('')
    const [hasError, setHasError] = useState(false);


    const formValues = { email, password };


    const isNullOrWhitespace = value => {
        if (!value || value.trim() === '') {
            return true;
        }
        return false;
    }

    const emailRegex = /^[a-zA-Z0-9.!#$%&"*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

    const handleFormSubmit = e => {
        e.preventDefault();
        if (isNullOrWhitespace(email) || isNullOrWhitespace(password) || !RegExp(emailRegex).test(email)) {
            setHasError(true);
        } else {
            AuthService.login(email, password);
        }
    }

    return (
        <div className="flex justify-center items-center w-full h-full min-w-screen min-h-screen">
            <div className="relative w-[500px] max-h-[calc(100vh-50px)] md:max-w-[400px] lg:max-w-[450px] bg-white rounded shadow-2xl">
                <div className="flex flex-col justify-center max-h-[calc(100vh-54px)] h-full  px-5 py-7 overflow-y-auto">
                    <LockOpenIcon className='w-10 h-10 text-bluePrimary mx-auto' />
                    <h3 className='text-center'>Prijava</h3>
                    <form className="w-full mt-8">
                        <div className="input-group">
                            <label className="font-medium text-xs text-gray-500">Email</label>
                            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="input-field" />
                            {hasError && (isNullOrWhitespace(email) || !RegExp(emailRegex).test(email)) && <span className="input-error">Please enter a valid email.</span>}
                        </div>
                        <div className="input-group mt-3">
                            <label className="font-medium text-xs text-gray-500">Šifra</label>
                            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="input-field" />
                            {hasError && isNullOrWhitespace(password) && <span className="input-error">Please enter password</span>}
                        </div>
                        <button type="submit" className="button without-icon bg-secondaryGradient mx-auto mt-5" onClick={e => handleFormSubmit(e)}>
                            Prijavi se
                        </button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Login
